import { render, staticRenderFns } from "./Solution.vue?vue&type=template&id=36fc353c"
import script from "./Solution.vue?vue&type=script&lang=js"
export * from "./Solution.vue?vue&type=script&lang=js"
import style0 from "./Solution.vue?vue&type=style&index=0&id=36fc353c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports